import type { SVGProps } from "react";
export interface ColorPaletteIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ColorPaletteIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ColorPaletteIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 11.5c0-4.805-3.908-8.375-8.882-8.375-4.897 0-8.868 3.973-8.868 8.876 0 4.913 3.904 8.873 8.79 8.874a.59.59 0 0 0 .59-.592c0-.195-.043-.272-.115-.35l-.016-.018a2.83 2.83 0 0 1-.699-1.844 2.744 2.744 0 0 1 2.744-2.745h2.117c2.539 0 4.338-1.588 4.338-3.827Zm2.25 0c0 3.761-3.108 6.075-6.59 6.076H14.42a.494.494 0 0 0-.494.495.58.58 0 0 0 .136.356c.48.53.695 1.16.695 1.856a2.84 2.84 0 0 1-2.842 2.841C5.762 23.125.875 18.133.875 12.002.875 5.857 5.852.875 11.993.875c6.063 0 11.131 4.43 11.132 10.624Z"
      />
      <path
        fill={color}
        d="M7.611 15.516a.62.62 0 0 0-.126.373l.014.126a.6.6 0 0 0 .112.246zm1 .745a.6.6 0 0 0 .112-.246l.013-.126-.013-.126a.6.6 0 0 0-.113-.247zm8.321-5.494a.62.62 0 0 0-.124.372l.011.126c.019.091.06.174.113.246zm1 .742a.6.6 0 0 0 .112-.244l.013-.126-.013-.126a.6.6 0 0 0-.111-.245v.741ZM7.18 11.013a.6.6 0 0 0-.111-.245v.741a.6.6 0 0 0 .111-.244l.013-.126zm-1.112-.245a.62.62 0 0 0-.124.37l.012.127a.6.6 0 0 0 .112.244zm7.93-4.04a.62.62 0 0 0-.125.37l.012.127a.6.6 0 0 0 .113.244zm1 .741a.6.6 0 0 0 .111-.244l.014-.126-.014-.126a.6.6 0 0 0-.11-.245v.741Zm-4.882-.496a.6.6 0 0 0-.113-.246v.744a.6.6 0 0 0 .113-.246l.013-.126zm-1.112-.246a.62.62 0 0 0-.126.372l.013.126a.6.6 0 0 0 .113.246zm.732 9.162a1.624 1.624 0 0 1-3.241.166l-.008-.166.008-.167a1.625 1.625 0 0 1 1.617-1.457l.165.007c.82.083 1.46.776 1.46 1.617Zm-1.542-4.75a1.625 1.625 0 0 1-3.242.167l-.009-.167.01-.166a1.625 1.625 0 0 1 1.615-1.459l.167.009a1.625 1.625 0 0 1 1.459 1.616m10.865 0a1.625 1.625 0 0 1-3.242.167l-.009-.167.009-.166a1.625 1.625 0 0 1 1.616-1.459l.167.009a1.626 1.626 0 0 1 1.459 1.616m-7.931-4.04a1.625 1.625 0 0 1-3.242.167l-.007-.167.007-.166a1.626 1.626 0 0 1 3.242.166m4.995 0a1.625 1.625 0 0 1-3.242.167l-.008-.167.008-.166a1.625 1.625 0 0 1 1.616-1.459l.167.009c.82.083 1.459.775 1.46 1.616Z"
      />
    </svg>
  );
}
